import React, { useRef } from 'react';
import "./contact.css";
import LinkedIn from "../../resources/linkedin.png";
import Instagram from "../../resources/instagram.png";
import  Github from "../../resources/github.png";
import emailjs from '@emailjs/browser';

const Contact = () => {
    const form = useRef();
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICEID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATEID;
    const publicKeyValue = process.env.REACT_APP_EMAILJS_PUBLICKEY;

    const sendEmail = (e) => {
        e.preventDefault();
        const formData = new FormData(form.current);
        const fromName = formData.get('from_name');
        const fromEmail = formData.get('from_email');
        const message = formData.get('message');

        if (!fromName || !fromEmail || !message) {
            alert( "Please fill out all fields" );
            return;
        }
        emailjs
          .sendForm(serviceId, templateId, form.current, {
            publicKey: publicKeyValue,
          })
          .then(
            () => {
              console.log('SUCCESS!');
              e.target.reset();
              alert('Email Sent. Thanks for contacting ')
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
      };

    return(
    <section id="contactPage">
        <div id="contact">
            <h1 id='ContactMeHeader' className='contactPageTitle'>Contact Me</h1>
            <span className='contactDesc'>Let's catchup to discuss work opportunities</span>
            <form className='contactForm' ref={form} onSubmit={sendEmail}>
                <input type="text" className='name' placeholder='Your Name' name='from_name' />
                <input type='email' className='email' placeholder='Your Email' name='from_email'/>
                <textarea name='message'className='msg' rows='5' placeholder='Your Message'></textarea>
                <button type='submit' value='Send' id="submitButton" className='submitBtn'>Submit</button>
            </form>
            
            <h1 className='contactPageTitle'>To find more about me</h1>
            <span className='contactDesc'>Find me on LinkedIn, GitHub or Instagram through the links below</span> <br></br>
            <a href="https://drive.google.com/file/d/1xPWOVI-KMJbPRiMfQO1Q3N7ifo92yCJO/view?usp=sharing" target='_blank'>
                <button className='ResumeButton'>Resume</button>
            </a>

            <div className='Socials'>
                    <a href="https://www.linkedin.com/in/abrajbhandari/" target='_blank'>
                      <img src={LinkedIn} alt='LinkedIn' className='link1'/>
                    </a>
                    <a href="https://www.instagram.com/abhash.rajbhandari/" target='_blank'>
                      <img src={Instagram} alt='Instagram' className='link2'/>
                    </a>
                    <a href="https://github.com/Abhash-rajbhandari" target='_blank'>
                      <img src={Github} alt='GitHub' className='link3'/>
                    </a>
            </div>

            

        </div>
    </section>
    );
}

export default Contact;